export default __webpack_public_path__ + "static/15-de0ab7cc58a7f516d67705b428f53d6f.jpg";